import PropTypes from 'prop-types';
import styled from 'styled-components';

const Tabs = ({ children, className }) => {
  return (
    <TabsWrapper className={className}>
      {children}
    </TabsWrapper>
  );
}

export default Tabs;

Tabs.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

const TabsWrapper = styled.ul`
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
`;